import Paper from "@mui/material/Paper";
import axios from "axios";
import moment from "moment-timezone";

import { DataGrid, GridColDef, GridToolbar } from "@mui/x-data-grid";
import { useSignal, useSignalEffect } from "@preact/signals-react";
import { useState } from "react";
import { app } from "../signals/AppSignal";

interface IUsers {
  id: number;
  dateAdded: string;
  accountId: string;
  slug: string;
  accountName: string;
  userId: string;
  userName: string;
  userEmail: string;
}

const Unauthorize = () => {
  useSignal(0);

  const [days, setDays] = useState<number>(1);
  const [inactive, setInactive] = useState<IUsers[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [paginationModel, setPaginationModel] = useState<{
    page: number;
    pageSize: number;
  }>({ page: 0, pageSize: 50 });

  const columns: GridColDef[] = [
    {
      field: "id",
      type: "number",
      headerAlign: "right",
      headerName: "#",
      width: 50,
    },
    {
      field: "accountId",
      type: "string",
      headerAlign: "left",
      headerName: " Account ID",
      sortable: true,
      width: 100,
    },
    {
      field: "slug",
      type: "string",
      headerAlign: "left",
      headerName: "Slug",
      sortable: true,
      width: 150,
    },
    {
      field: "accountName",
      type: "string",
      headerAlign: "left",
      headerName: "Account Name",
      sortable: true,
      width: 150,
    },
    {
      field: "userId",
      type: "string",
      headerAlign: "left",
      headerName: " User ID",
      sortable: true,
      width: 100,
    },
    {
      field: "userName",
      type: "string",
      headerAlign: "left",
      headerName: "User Name",
      sortable: true,
      width: 150,
    },
    {
      field: "userEmail",
      type: "string",
      headerAlign: "left",
      headerName: "Email",
      sortable: true,
      width: 200,
    },
    {
      field: "dateAdded",
      type: "string",
      headerAlign: "left",
      headerName: "Date Added",
      sortable: true,
      width: 200,
    },
  ];

  const convertUTCToLocal = (utcDateStr: string) => {
    return moment
      .utc(utcDateStr) // Parse as UTC
      .tz(moment.tz.guess())
      .format("MMMM D, YYYY, HH:mm:ss");
  };

  const getUnauthorizeUser = async () => {
    setLoading(true);
    setInactive([]);
    axios
      .get(`/api/v1/reports/${app.value}/unauthorize`)
      .then((response) => {
        // handle success
        console.log(response.data);
        setPaginationModel({
          page: response.data.currentPage,
          pageSize: response.data.pageSize,
        });

        let usersList: IUsers[] = response.data.data || [];
        usersList = usersList.map((list, index) => ({
          ...list,
          id: index + 1,
          dateAdded: convertUTCToLocal(list.dateAdded),
        }));
        setInactive(usersList);
      })
      .catch((error) => {
        // handle error
        console.log(error);
        setInactive([]);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useSignalEffect(() => {
    if (days) {
      getUnauthorizeUser();
    }
  });

  return (
    <div className="row mt-2">
      <div className="col-12">
        <div className="card">
          <div className="card-header">
            <div className="d-lg-flex">
              <div>
                <h5 className="mb-0">Unauthorize</h5>
              </div>
              <div className="ms-auto my-auto mt-lg-0 mt-4">
                <div className="ms-auto my-auto">
                  <button
                    type="button"
                    className="btn btn-icon-only btn-rounded btn-secondary mb-0 ms-2 btn-sm d-flex align-items-center justify-content-center ms-auto"
                    data-bs-toggle="tooltip"
                    data-bs-placement="bottom"
                    title="Refresh"
                    onClick={() => getUnauthorizeUser()}
                  >
                    <i className="material-symbols-rounded text-md">sync</i>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="card-body">
            <Paper sx={{ height: "550px", width: "100%" }}>
              <DataGrid
                loading={loading}
                rows={inactive}
                columns={columns}
                slots={{ toolbar: GridToolbar }}
                initialState={{ pagination: { paginationModel } }}
                pageSizeOptions={[10, 20, 30, 40, 50]}
                localeText={{ noRowsLabel: "No data available to display" }}
                disableRowSelectionOnClick
                sx={{ border: 0 }}
              />
            </Paper>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Unauthorize;
